(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ootw-hero-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  class OOTWHeroSlider {
    constructor(el) {
      this.el = el;
      this.current = 0;
      this.animating = false;
      this.timer = null;
      this.safetyTimer = null;
      this.autoplay = el.dataset.autoplay === 'true';
      this.speed = parseInt(el.dataset.autoplaySpeed, 10) || 5000;

      this.bgLayers  = Array.from(el.querySelectorAll('.ootw-bg-layer'));
      this.panels    = Array.from(el.querySelectorAll('.ootw-panel'));
      this.imgSlides = Array.from(el.querySelectorAll('.ootw-img-slide'));
      this.tabs      = Array.from(el.querySelectorAll('.ootw-tab'));
      this.shopNow   = el.querySelector('[data-shopnow]');
      this.total     = this.tabs.length;

      if (this.total < 2) return;

      /* Store instance on element so visibility handler can reach it */
      el._ootwInstance = this;

      this._bindEvents();
      this._syncShopNow(0);
      if (this.autoplay) this._startTimer();
    }

    _bindEvents() {
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          var idx = parseInt(tab.dataset.tab, 10);
          if (idx !== this.current && !this.animating) this._goTo(idx);
        });
      });

      this.el.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft')  this._goTo((this.current - 1 + this.total) % this.total);
        if (e.key === 'ArrowRight') this._goTo((this.current + 1) % this.total);
      });

      if (this.autoplay) {
        this.el.addEventListener('mouseenter', () => this._stopTimer());
        this.el.addEventListener('mouseleave', () => this._startTimer());
        this.el.addEventListener('focusin',    () => this._stopTimer());
        this.el.addEventListener('focusout',   () => this._startTimer());
      }
    }

    _goTo(next) {
      if (next === this.current || this.animating) return;
      this.animating = true;

      var prev = this.current;
      this.current = next;

      /* 1. Background layers */
      this.bgLayers.forEach(function (l, i) { l.classList.toggle('is-active', i === next); });

      /* 2. Text panels */
      this.panels.forEach(function (p, i) { p.classList.toggle('is-active', i === next); });

      /* 3. Product images: slide */
      var leaving  = this.imgSlides[prev];
      var entering = this.imgSlides[next];

      leaving.classList.remove('is-active');
      leaving.classList.add('is-leaving');
      entering.classList.add('is-entering');
      entering.setAttribute('aria-hidden', 'false');
      leaving.setAttribute('aria-hidden', 'true');

      var self = this;

      /* Clear any previous safety timer */
      if (this.safetyTimer) { clearTimeout(this.safetyTimer); this.safetyTimer = null; }

      var cleanup = function () {
        /* Guard: only run once */
        if (!self.animating) return;
        self.animating = false;
        leaving.classList.remove('is-leaving');
        entering.classList.remove('is-entering');
        entering.classList.add('is-active');
        leaving.removeEventListener('animationend', onLeave);
        entering.removeEventListener('animationend', onEnter);
        if (self.safetyTimer) { clearTimeout(self.safetyTimer); self.safetyTimer = null; }
      };

      var onLeave = function () { leaving.classList.remove('is-leaving'); };
      var onEnter = function () { cleanup(); };

      leaving.addEventListener('animationend', onLeave,  { once: true });
      entering.addEventListener('animationend', onEnter, { once: true });

      /* Safety: complete transition if animationend never fires (tab hidden, reduced-motion, etc.) */
      this.safetyTimer = setTimeout(cleanup, 900);

      /* 4. Tabs */
      this.tabs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === next);
        t.setAttribute('aria-selected', String(i === next));
      });

      /* 5. Shop Now */
      this._syncShopNow(next);

      if (this.autoplay) this._startTimer();
    }

    /* Reset all slides to a clean state matching this.current.
       Called when the page becomes visible again after being hidden. */
    _forceResetState() {
      if (this.safetyTimer) { clearTimeout(this.safetyTimer); this.safetyTimer = null; }
      this.animating = false;
      var current = this.current;
      this.imgSlides.forEach(function (slide, i) {
        slide.classList.remove('is-entering', 'is-leaving');
        slide.classList.toggle('is-active', i === current);
        slide.setAttribute('aria-hidden', String(i !== current));
      });
      this.bgLayers.forEach(function (l, i) { l.classList.toggle('is-active', i === current); });
      this.panels.forEach(function (p, i) { p.classList.toggle('is-active', i === current); });
      this.tabs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === current);
        t.setAttribute('aria-selected', String(i === current));
      });
    }

    _syncShopNow(idx) {
      if (!this.shopNow) return;
      var tab = this.tabs[idx];
      if (!tab) return;
      this.shopNow.href        = tab.dataset.ctaUrl   || '#';
      this.shopNow.textContent = tab.dataset.ctaLabel || 'Shop Now';
      var btnBg = (tab.dataset.btnBg || '').trim();
      if (btnBg && btnBg !== 'rgba(0,0,0,0)' && btnBg !== '#000000' && btnBg.length > 3) {
        this.shopNow.style.setProperty('--shopnow-bg', btnBg);
        this.shopNow.style.backgroundImage = 'linear-gradient(180deg,color-mix(in srgb,' + btnBg + ' 90%,#fff) 0%,' + btnBg + ' 50%,color-mix(in srgb,' + btnBg + ' 90%,#000) 100%)';
      } else {
        this.shopNow.style.removeProperty('--shopnow-bg');
        this.shopNow.style.backgroundImage = '';
      }
    }

    _startTimer() {
      this._stopTimer();
      var self = this;
      this.timer = setInterval(function () {
        self._goTo((self.current + 1) % self.total);
      }, this.speed);
    }

    _stopTimer() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
    }
  }

  /* ---- Discount wallet: 3-D tilt + glare + touch-toggle ---- */
  function initWallet(wallet) {
    var cards = Array.from(wallet.querySelectorAll('.ootw-dw-card-el'));

    cards.forEach(function (card) {
      var glare = card.querySelector('.ootw-dw-glare');
      var tiltRaf = null;
      var mx = 0, my = 0;

      function applyTilt(e) {
        mx = e.clientX; my = e.clientY;
        if (tiltRaf) return;
        tiltRaf = requestAnimationFrame(function () {
          tiltRaf = null;
          var r = card.getBoundingClientRect();
          var x = (mx - r.left) / r.width;
          var y = (my - r.top) / r.height;
          var rx = (y - 0.5) * -16;
          var ry = (x - 0.5) * 12;
          card.style.transition = 'none';
          card.style.transform = 'rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) scale(1.04)';
          if (glare) {
            glare.style.background = 'radial-gradient(circle at ' + (x * 100) + '% ' + (y * 100) + '%, rgba(255,255,255,0.16) 0%, transparent 62%)';
            glare.style.opacity = '1';
          }
        });
      }

      function resetTilt() {
        if (tiltRaf) { cancelAnimationFrame(tiltRaf); tiltRaf = null; }
        card.style.transition = 'transform 0.55s cubic-bezier(0.34,1.56,0.64,1)';
        card.style.transform = '';
        if (glare) { glare.style.opacity = '0'; }
      }

      card.addEventListener('mousemove', applyTilt);
      card.addEventListener('mouseleave', resetTilt);
    });

    /* Touch: tap wallet body (not a card) to toggle fan-out */
    var fanned = false;
    wallet.addEventListener('touchend', function (e) {
      if (!e.target.closest('.ootw-dw-card-el')) {
        e.preventDefault();
        fanned = !fanned;
        wallet.classList.toggle('is-fanned', fanned);
      }
    }, { passive: false });
  }

  function initWallets() {
    document.querySelectorAll('.ootw-discount-wallet').forEach(function (w) {
      if (!w.dataset.walletInit) { w.dataset.walletInit = '1'; initWallet(w); }
    });
  }

  /* Page visibility fix: when the user returns to the tab, force-reset every slider
     to prevent images left in is-entering / is-leaving stuck states. */
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      document.querySelectorAll('.ootw-hero').forEach(function (el) {
        if (el._ootwInstance) el._ootwInstance._forceResetState();
      });
    }
  });

  function init() {
    document.querySelectorAll('.ootw-hero').forEach(function (el) {
      if (!el.dataset.ootwInit) {
        el.dataset.ootwInit = '1';
        new OOTWHeroSlider(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); initWallets(); });
  } else {
    init();
    initWallets();
  }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.ootw-hero').forEach(function (el) {
      delete el.dataset.ootwInit;
      if (el._ootwInstance) { delete el._ootwInstance; }
      new OOTWHeroSlider(el);
    });
    e.target.querySelectorAll('.ootw-discount-wallet').forEach(function (w) {
      delete w.dataset.walletInit;
      initWallet(w);
      w.dataset.walletInit = '1';
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
